/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect } from 'react'
import { QS_CONFIG } from '../Utilities'

export const FIELD_TYPES = {
    RANGE: 'RANGE',
    CHECKBOXES: 'CHECKBOXES',
    SELECT: 'SELECT'
}

const currentFieldEmpty = {options: []}

export function useFormHook({
    dependencies,
    QueryParser = QS_CONFIG,
    initialState = [],
    modalStateFilter={}
}) {
    const [state, setState] = useState(() => {
        const finalInitialState = {}
        for (let i = 0; i < initialState.length; i++) {
            let newField = { ...initialState[i] }
            if (newField.type === FIELD_TYPES.RANGE) {
                newField['value'] = {
                    from: '',
                    to: ''
                }
            }
            if (!newField.hasOwnProperty('options')) newField['options'] = []
            if(modalStateFilter[newField.key]){
                if(newField.type === FIELD_TYPES.CHECKBOXES){
                    newField = {...newField, options: modalStateFilter[newField.key].options}
                } else if (newField.type === FIELD_TYPES.RANGE){
                    newField = {...newField, value: {...modalStateFilter[newField.key].value}}
                }
            }
            finalInitialState[newField.key] = { ...newField }
        }
        return finalInitialState
    })

    const updateStateWithAsyncFunc = async _ => {
        let oldState = { ...state }
        const keys = Object.keys(oldState)
        for (let index = 0; index < keys.length; index++) {
            const key = keys[index]
            const newField = oldState[key]

            if (newField.hasOwnProperty('asyncFuntion')) {
                let data = []
                if (dependencies) {
                    const keyParent = Object.keys(dependencies).filter(keyFilter =>
                        modalStateFilter.hasOwnProperty(keyFilter) && dependencies[keyFilter].find(depkey => depkey === newField.key)
                    )
                    if (modalStateFilter[newField.key] && modalStateFilter[newField.key].params?.reFetch) {
                        data = await newField.asyncFuntion({params:newField?.params,field: modalStateFilter[keyParent.slice(-1)], currentField: modalStateFilter[newField.key]})
                    } else {
                        const fieldExist = modalStateFilter[keyParent.slice(-1)] || null
                        const currentFieldExist = modalStateFilter[newField.key] || currentFieldEmpty
                        data = await newField.asyncFuntion({params:newField?.params, field: fieldExist, currentField: currentFieldExist, currentState: modalStateFilter})
                    }
                } else {
                    data = await newField.asyncFuntion({params:newField?.params, currentField: currentFieldEmpty, currentState: modalStateFilter})
                }
                newField['options'] = data || []
                oldState = { ...oldState, [key]: { ...newField } }
            }
        }
        setState(oldState)
    }

    useEffect(() => {
        (async () => {
            await updateStateWithAsyncFunc()
        })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // **************************** FILTER HANDLERS ****************************
    // this is just a parser to parse the filter object to a querystring
    const _buildNewQuery = obj => {
        const currState = { ...state }
        // console.log(`currState `, currState)

        // bail if there isn't an object
        if (!obj)
            return console.warn('_buildNewQuery called with null argument')
        // bail if there isn't a location.state -- state not initialized
        if (!currState)
            return console.warn(
                '_buildNewQuery called before state initialization'
            )

        const key = Object.keys(obj)[0]
        let field = { ...currState[key] }
        if (field.type === FIELD_TYPES.CHECKBOXES) {
            field = { ...field, options: Object.values(obj)[0] }
        } else if (field.type === FIELD_TYPES.RANGE) {
            field = { ...field, value: Object.values(obj)[0] }
        }

        const newState = { ...currState, [field.key]: { ...field } }

        // check and clean dependencies
        // for the props changed, delete the keys that depend on that prop
        // example: { brand_id: ['model_id', 'version_id'] }.
        // this "Dependencies" object will remove model_id and version_id
        // but only if the "obj" has the prop "brand_id" and this prop changes
        // from the previous value

        // obj
        // {'branch_office': []}
        setState(newState)
        if (dependencies) {
            // obtenemos las keys de los fields a actualizar
            const keyToUpdate = Object.keys(dependencies).filter(keyFilter =>
                obj.hasOwnProperty(keyFilter)
            )
            if(!keyToUpdate.length) return
            const dependenciesToUpdate = dependencies[keyToUpdate[0]]

            if(field.type === FIELD_TYPES.CHECKBOXES){
                const hasCheckeds = field.options.find(opt=>opt.checked)
                if(!hasCheckeds){
                    dependenciesToUpdate.forEach(keyDepencey => {
                        (async _ => {
                        const newFieldToUpdate = state[keyDepencey]
                            if(newFieldToUpdate.type === FIELD_TYPES.CHECKBOXES){
                                if (newFieldToUpdate?.params?.optionalDependencies?.find(od => od === keyToUpdate[0])) {
                                        newFieldToUpdate.options = await newFieldToUpdate.asyncFuntion({field, params:newFieldToUpdate?.params, currentState: state})
                                    } else {
                                        newFieldToUpdate.options = [];
                                    }
                            } else if(newFieldToUpdate.type === FIELD_TYPES.RANGE) {
                                newFieldToUpdate.value = {from: '', to: ''};
                            }
                            setState({...state, [newFieldToUpdate.key]: {...newFieldToUpdate}})
                        })()
                    })
                } else {
                    (async _ => {
                        for (let index = 0; index < dependenciesToUpdate.length; index++) {
                            const dtoUpdateKey = dependenciesToUpdate[index]
                            const newField = state[dtoUpdateKey]
                            if (newField.hasOwnProperty('asyncFuntion')) {
                                if (typeof newField.loading === 'boolean') {
                                    setState({...state, [newField.key]: {...newField, loading: true}})
                                }
                                const data = await newField.asyncFuntion({field, params:newField?.params, currentField: currentFieldEmpty, currentState: state})
                                newField['options'] = data || []
                                if (typeof newField.loading === 'boolean') {
                                    newField['loading'] = false;
                                }
                                setState({...state, [newField.key]: {...newField}})
                            }
                        }
                    })()
                }
            }
        }
    }

    const _changeOneValue = ({ name, value, toggle }) => {
        const currQuery = state
        const prevValue = currQuery[name]
        // if it's the same value and toggle flag is specified, remove the value
        if (prevValue === value && toggle === true) {
            _buildNewQuery({ [name]: undefined })
        } else {
            _buildNewQuery({ [name]: value })
        }
    }

    const onChangeForm = obj => {
        // console.log(obj)
        if (obj && obj.hasOwnProperty('name') && obj.hasOwnProperty('value')) {
            _changeOneValue(obj)
        } else {
            _buildNewQuery(obj)
        }
    }

    const clearForm = () => {
        const newState = {}

        Object.values(state).forEach(field => {
            newState[field.key] = { ...field }
            newState[field.key].order = field.order+1;
            if (field.type === FIELD_TYPES.CHECKBOXES) {
                const includeDependencies = Object.values(dependencies || {}).filter(dep => dep.includes(field.key)).length;
                if(includeDependencies){
                    newState[field.key].options = [];
                 } else {
                    newState[field.key].options =
                    field.options?.map(opt => (opt.disabled ? opt : { ...opt, checked: false })) ||
                    []
                }

            } else if (field.type === FIELD_TYPES.RANGE) {
                newState[field.key].value = { from: '', to: '' }
            }
        })

        setState(newState)
    }

    return {
        state,
        onChangeForm,
        clearForm
    }
}
